var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaidsSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.106,
    height: 55.729,
    viewBox: "0 0 62.106 55.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maids-svgrepo-com",
    transform: "translate(0 -26.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35815",
    "data-name": "Group 35815",
    transform: "translate(42.059 40.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35814",
    "data-name": "Group 35814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M349.151,141.211a4.436,4.436,0,0,0-2.421,1.8c.832,2.389,2.527,7.229,3.371,9.638.519-3.019.884-6.26.884-6.26Z",
    transform: "translate(-346.73 -141.211)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35817",
    "data-name": "Group 35817",
    transform: "translate(45.053 30.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35816",
    "data-name": "Group 35816"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_570",
    "data-name": "Ellipse 570",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35819",
    "data-name": "Group 35819",
    transform: "translate(41.17 40.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35818",
    "data-name": "Group 35818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M360.225,157.734c-.038-.108-3.8-10.828-4.388-12.548-.766-2.229-1.95-3.573-3.527-4.013l-1.795,5.064s1.036,7.024,2.08,13.254a1.007,1.007,0,0,1-.992,1.178h-8.13a1,1,0,0,1-.855-.48,3.925,3.925,0,0,1-2.52.311l-.349,1.8a2.977,2.977,0,0,1-.346,2.262,1.138,1.138,0,0,0,1.114.907h1.565v14.882a2.462,2.462,0,1,0,4.924,0V165.468h1.063V180.35a2.462,2.462,0,0,0,4.924,0V165.468h1.565a1.14,1.14,0,0,0,1.119-1.358c-3.147-16.248-2.806-14.391-2.912-15.262,1.272,3.643,3.466,9.9,3.586,10.243a2.052,2.052,0,0,0,3.872-1.358Z",
    transform: "translate(-339.405 -141.172)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35821",
    "data-name": "Group 35821",
    transform: "translate(46.117 40.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35820",
    "data-name": "Group 35820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M380.183,139.844l1.781,5.025h2.758l1.781-5.025Z",
    transform: "translate(-380.183 -139.844)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35823",
    "data-name": "Group 35823",
    transform: "translate(8.588 30.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35822",
    "data-name": "Group 35822"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_571",
    "data-name": "Ellipse 571",
    cx: 4.252,
    cy: 4.252,
    r: 4.252,
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35825",
    "data-name": "Group 35825",
    transform: "translate(0 40.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35824",
    "data-name": "Group 35824",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M20.63,162.343l-.352-1.816a3.924,3.924,0,0,1-2.527-.288,1,1,0,0,1-.847.465H8.774a1.008,1.008,0,0,1-.992-1.178c1.912-11.127,1.471-8.271,2.066-13.135l-1.835-5.178c-1.569.445-2.747,1.787-3.51,4.008C3.912,146.942.154,157.662.116,157.77a2.052,2.052,0,0,0,3.872,1.358c.121-.346,2.382-6.8,3.644-10.41-.132,1.079.248-.992-2.933,15.43A1.142,1.142,0,0,0,5.819,165.5H7.384v14.882a2.462,2.462,0,0,0,4.924,0V165.5h1.063v14.882a2.462,2.462,0,0,0,4.924,0V165.5H19.86a1.136,1.136,0,0,0,1.115-.911A2.972,2.972,0,0,1,20.63,162.343Z",
    transform: "translate(0 -141.213)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35827",
    "data-name": "Group 35827",
    transform: "translate(15.816 40.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35826",
    "data-name": "Group 35826",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M132.177,141.172l-1.795,5.064c.584,4.776.383,3.377.886,6.305.831-2.371,2.523-7.2,3.346-9.566A4.433,4.433,0,0,0,132.177,141.172Z",
    transform: "translate(-130.382 -141.172)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35829",
    "data-name": "Group 35829",
    transform: "translate(9.651 40.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35828",
    "data-name": "Group 35828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M79.565,139.844l1.781,5.025H84.1l1.781-5.025Z",
    transform: "translate(-79.565 -139.844)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35831",
    "data-name": "Group 35831",
    transform: "translate(17.24 37.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35830",
    "data-name": "Group 35830",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M169.625,133.223c-.7-2.009-4.008-11.432-4.7-13.441l-.018-.052c-.673-1.957-1.811-3.773-3.8-4.329l-1.936,5.463s.186,2.319,2.244,14.3a1.086,1.086,0,0,1-1.07,1.271h-8.77a1.088,1.088,0,0,1-1.07-1.271c2.062-12,2.229-14.17,2.229-14.17l-1.979-5.585c-1.693.48-2.963,1.928-3.787,4.324-.591,1.721-4.07,11.646-4.653,13.31a2.219,2.219,0,1,0,4.1,1.691c.131-.373,2.57-7.33,3.931-11.23l-3.163,16.644a1.232,1.232,0,0,0,1.207,1.465h1.689v16.054a2.656,2.656,0,0,0,5.312,0V141.611h1.147v16.054a2.656,2.656,0,0,0,5.312,0V141.611h1.689a1.231,1.231,0,0,0,1.207-1.465c-3.385-17.475-3.025-15.513-3.142-16.464,1.372,3.929,3.739,10.682,3.868,11.05a2.213,2.213,0,1,0,4.162-1.508Z",
    transform: "translate(-142.123 -115.401)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35833",
    "data-name": "Group 35833",
    transform: "translate(27.635 36.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35832",
    "data-name": "Group 35832",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M227.817,113.968l1.921,5.421h2.976l1.921-5.421Z",
    transform: "translate(-227.817 -113.968)",
    fill: "#4d9348"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35835",
    "data-name": "Group 35835",
    transform: "translate(26.487 26.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35834",
    "data-name": "Group 35834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M222.943,26.289a4.587,4.587,0,1,0,4.587,4.587A4.587,4.587,0,0,0,222.943,26.289Z",
    transform: "translate(-218.356 -26.289)",
    fill: "#4d9348"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaidsSvgrepoCom);
export default __webpack_public_path__ + "static/media/maids-svgrepo-com.29a3afc0968268782ceb88f5daa9cf07.svg";
export { ForwardRef as ReactComponent };